import { storeHelpers } from 'src/utils/store';
import type { AnyAction, SerializedError } from '@reduxjs/toolkit';
import { createReducer } from '@reduxjs/toolkit';

import { apiRejectedActions } from './actions';

const initialState: Record<AnyAction['type'], SerializedError | false> = {};

export const apiRejectedReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(apiRejectedActions.clearRejected, (state, action) => ({
      ...state,
      [action.payload]: false,
    }))
    .addMatcher(storeHelpers.getIsActionRejected, (state, action) => ({
      ...state,
      [storeHelpers.getBaseAction(action.type, 'rejected')]: action.error,
    }))
    .addMatcher(storeHelpers.getIsActionPending, (state, action) => ({
      ...state,
      [storeHelpers.getBaseAction(action.type, 'pending')]: false,
    }))
    .addMatcher(storeHelpers.getIsActionFulfilled, (state, action) => ({
      ...state,
      [storeHelpers.getBaseAction(action.type, 'fulfilled')]: false,
    }))
    .addMatcher(storeHelpers.getIsActionFulfilled, (state, action) => ({
      ...state,
      [storeHelpers.getBaseAction(action.type, 'fulfilled')]: false,
    })),
);
